import { useMemo } from 'react';

import { useAdditionalFieldStateStore } from '../Additional/stores';
import { useCardOfferedFieldsStateStore } from '../CardOffered/stores';
import { usePlanNameFieldsStateStore } from '../PlanName/stores';
import { usePlanYearFieldsStateStore } from '../PlanYear/stores';

export default () => {
  const planNameStore = usePlanNameFieldsStateStore((state) => state.state);

  const cardOfferedStore = useCardOfferedFieldsStateStore((state) => state.state);
  const additionalStore = useAdditionalFieldStateStore((state) => state.state);
  const planYearFieldsStateStore = usePlanYearFieldsStateStore((state) => state.state);

  const state = useMemo(() => ({
    ...planNameStore,

    ...cardOfferedStore,
    ...additionalStore,
    ...planYearFieldsStateStore,
  }), [additionalStore, cardOfferedStore, planNameStore, planYearFieldsStateStore]);
  return state;
};
